import RadioButtonList from './RadioButtonList';
import SuggestedAmountButton from './SuggestedAmountButton';

/**
 * @callback OnChangeCallback
 * @param {SuggestedAmountButton} btn
 */

class OnePageGivingButtons {
  /** @type {SuggestedAmountButton[]} */
  suggestedAmountButtons = [];

  /**
   * @param {HTMLFormElement} $form
   * @param {OnChangeCallback} onChange
   */
  constructor($form, onChange = () => {}) {
    const $ul = $form.querySelector('.tn-opg-form__suggested-amount-list');

    if (!$ul) {
      return;
    }

    this.onChange = onChange;
    this.buttonsById = {};

    this.list = new RadioButtonList($form, $ul, this.onListChange);

    const btns = this.list.getItems().map(($li) => new SuggestedAmountButton($li));

    this.suggestedAmountButtons = btns.filter((btn) => !btn.isOtherAmountButton);
    this.currentButton = btns.find((btn) => btn.getIsSelected());

    btns.forEach((btn) => { this.buttonsById[btn.id] = btn; });
  }

  onListChange = () => {
    const { id } = this.list.getSelectedItem();

    const button = this.buttonsById[id];

    this.onChange(button);
  };
}

export default OnePageGivingButtons;
